<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :rules="validationRules"
  >
    <div :class="{'validation-failed':failed}">
      <item-name :item="item" />
      <input
        v-model="value"
        type="date"
        date-format="dd/mm/yyyy"
        class="appearance-none px-4 py-4 bg-gray-800 text-gray-100 w-full border-3 border-transparent outline-none focus:border-orange-700 max-w-xs"
      >
      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import 'date-input-polyfill'
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

  date-input-polyfill {
    background: #fff;
    color: #000;
    text-shadow: none;
    border: 0;
    padding: 0;
    height: auto;
    width: auto;
    line-height: normal;
    font-family: sans-serif;
    position: absolute !important;
    text-align: center;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.22);
    cursor: default;
    z-index: 1;
    border-radius: 5px;
    overflow: hidden;
    display: block;
  }
  date-input-polyfill[data-open="false"] {
    visibility: hidden;
    z-index: -100 !important;
    top: 0;
  }
  date-input-polyfill[data-open="true"] {
    visibility: visible;
  }
  date-input-polyfill select,
  date-input-polyfill table,
  date-input-polyfill th,
  date-input-polyfill td {
    background: #fff;
    color: #000;
    text-shadow: none;
    border: 0;
    padding: 0;
    height: auto;
    width: auto;
    line-height: normal;
    font-family: sans-serif;
    box-shadow: none;
  }
  date-input-polyfill select,
  date-input-polyfill button {
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #DADFE1;
    height: 24px;
    vertical-align: top;
    appearance: none;
    padding: 0.25rem;
  }
  date-input-polyfill .monthSelect-wrapper {
    width: 55%;
    display: inline-block;
  }
  date-input-polyfill .yearSelect-wrapper {
    width: 25%;
    display: inline-block;
  }
  date-input-polyfill select {
    width: 100%;
  }
  date-input-polyfill select:first-of-type {
    border-right: 1px solid #DADFE1;
    border-radius: 5px 0 0 0;
  }
  date-input-polyfill button {
    width: 20%;
    background: #DADFE1;
    border-radius: 0 5px 0 0;
  }
  date-input-polyfill button:hover {
    background: #eee;
  }
  date-input-polyfill table {
    border-collapse: separate !important;
    border-radius: 0 0 5px 5px;
    overflow: hidden;
    max-width: 280px;
    width: 280px;
  }
  date-input-polyfill th,
  date-input-polyfill td {
    width: 32px;
    padding: 4px;
    text-align: center;
    box-sizing: content-box;
  }
  date-input-polyfill td[data-day] {
    cursor: pointer;
  }
  date-input-polyfill td[data-day]:hover {
    background: #DADFE1;
  }
  date-input-polyfill [data-selected] {
    font-weight: bold;
    background: #D8EAF6;
  }

</style>
